import React, { useState, useEffect } from "react";
import { Profile, ChatWindow } from "../../Components";

export default function InfMessage({
  chatInfo,
  onStartChat,
  cartItem,
  closeCartPanel,
  setAuth,
  setModal,
  user,
  NotifModul,
  profiles,
  setModalNotification,
  locationData,
}) {
  return (
    <>
      <div className="main">
        <div className="main__inner">
          {/* <div className="main__inner-title">
                        <h2>Chat</h2>
                        <Profile
                            user={user}
                            setAuth={setAuth}
                            setModal={setModal}
                            NotifModul={NotifModul}
                            profiles={profiles}
                            setNotifModul={setModalNotification}
                        />
                    </div> */}
          {user && (
            <div className="billing dashboard">
              <ChatWindow
                user={user}
                chatInfo={chatInfo}
                onStartChat={onStartChat}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
